import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/lp-logo-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "ly-col ly-center-center reset-password-container"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 1,
  class: "ly-col ly-center-center reset-password-container"
}

import { ref, Ref, onMounted, inject } from 'vue'
import { useConfig } from '@/config/useConfig'
import { Redirect } from '@/types/redirect'

const triggerRefreshTokenOnLoad = true
// in minutes

export default /*@__PURE__*/_defineComponent({
  __name: 'RefreshAccessToken',
  setup(__props) {


const postMessageToParentWindow = inject('postMessageToParentWindow') as (message: object, target: string) => void
const redirect = inject('redirect') as Redirect
const getQueryParameter = inject('getQueryParameter') as (paramName: string) => string
const countdownText: Ref<string> = ref('')
const renewingToken: Ref<boolean> = ref(false)
let countDownCurrent: number
let setIntervalReference: number

const updateCountdown = async () => {
  if (countDownCurrent === undefined) countDownCurrent = getSecondsToRefreshToken(getQueryParameter('accessToken'))
  let minutes = Math.floor(countDownCurrent / 60)
  let seconds = Math.floor(countDownCurrent % 60)

  minutes = minutes < 10 ? 0 + minutes : minutes
  seconds = seconds < 10 ? 0 + seconds : seconds

  const leftMessage = `00${minutes}`
  const rightMessage = `00${seconds}`

  countdownText.value = leftMessage.substring(leftMessage.length - 2) + ':' + rightMessage.substring(rightMessage.length - 2)

  countDownCurrent--

  if (countDownCurrent < 0) {
    await timerEnded()
  }
}

const timerEnded = async () => {
  clearInterval(setIntervalReference)
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'timeEnded' }, config.sso.lms_url)
}

const cancelRefresh = async () => {
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'refreshCanceled' }, config.sso.lms_url)
}

const refreshToken = async () => {
  const config = await useConfig()
  renewingToken.value = true
  clearInterval(setIntervalReference)
  redirect(`${config.api.url}${config.api.service_path}/auth/refreshToken`, true)
}

const init = async () => {
  if (triggerRefreshTokenOnLoad) {
    refreshToken()
  } else {
    await updateCountdown()
    setIntervalReference = setInterval(updateCountdown, 1000)
  }
}

onMounted(init)

const getSecondsToRefreshToken = (token: string) => {
  const payload = parseJwt(token)
  const refreshTokenTimeWindow = 60000 * 2
  const milisecondsToRefreshToken = (payload.exp * 1000) - refreshTokenTimeWindow - Date.now()
  const seconds = Math.floor(milisecondsToRefreshToken / 1000)
  return seconds < 1 ? 1 : seconds
}

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}


return (_ctx: any,_cache: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!renewingToken.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: _imports_0,
            class: "mb-3"
          }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, "Your session will expire in: " + _toDisplayString(countdownText.value), 1),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Do you want to renew the session?", -1)),
            _createVNode(_component_lp_button, {
              onClick: refreshToken,
              type: "primary"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Renew", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_lp_button, { onClick: cancelRefresh }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (renewingToken.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "mb-3"
          }, null, -1),
          _createElementVNode("div", { class: "card" }, [
            _createElementVNode("h3", null, "Your session is being refreshed. Please wait")
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})